import { getNumberFormat } from './getNumberFormat'

// Module-level constant so getNumberFormat() takes its identity path — see the
// header there.
const NUMBER_OPTIONS: Intl.NumberFormatOptions = {
  style: 'decimal',
  maximumFractionDigits: 2,
  minimumFractionDigits: 0,
  notation: 'compact',
}

export function formatNumber(amount: number | string | null) {
  // New formatting
  if (amount === undefined || (typeof amount === 'string' && amount === '')) {
    return '--'
  }
  if (amount === null) {
    return ''
  }
  if (amount === 0) {
    return '--'
  }

  const amountToUse = typeof amount === 'string' ? parseFloat(amount) : amount

  if (isNaN(amountToUse)) {
    // Not a valid number; may be a string such as 'N/A'
    return amount
  }

  return getNumberFormat('en-US', NUMBER_OPTIONS).format(amountToUse)
}
